/* eslint-disable react/prop-types */
// import Konva from 'konva';
// import { Textures } from './Textures';
import React from 'react';
import BrushShape from './BrushShape';

function Brush (props) {
  return (
    <React.Fragment>
        <BrushShape
            {...props}
            type={props.type}
            // selectedTextureIndex={props.selectedTextureIndex}
            // selectedFormIndex={props.selectedFormIndex}
        ></BrushShape>
    </React.Fragment>

  );
}

export default Brush;
